<template>
  <div class="new-modal-top-nav-center">
    <img :alt="headerTitle"
      v-show="headerImg"
      :class="[ {'new-modal-top-nav-center-img-title': !headerTitle},
       {'new-modal-top-nav-center-img-subtitle': headerTitle} ]"
      :src="`${assetsPath}/images/common/customs_logo_red.png`"/>
    <ugc-steps-view v-if="showStepsView"></ugc-steps-view>
    <h4
      v-else
      v-show="headerTitle"
      id="customs-vmodal-header-title"
      > {{ headerTitle }}
    </h4>
  </div>
</template>

<script>
import UgcStepsView from "@/components/UGC/TopBar/StepsView";
export default {
  name: 'modalTopNav',
  components: {
    UgcStepsView
  },
  props: {
    headerImg: {
      type: Boolean,
      default: true
    },
    headerTitle: {
      type: String,
      default: ''
    },
    showStepsView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    assetsPath() {
      return this.$store.state.endPoints.customizer.customsAssets || this.$store.state.endPoints.ugcentrypoint.customsAssets;
    }
  }
}
</script>
